'use client';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '#/components/ui/breadcrumb';
import { t } from 'intl-lib';
import Link from 'next/link';
import { useSelectedLayoutSegments } from 'next/navigation';
import { Fragment, ReactNode } from 'react';

// Define custom labels for specific routes
const routeLabels: Record<string, ReactNode> = {
  '/dashboard': t('PortfolioDashboard.Heading'),
  '/reporting': t('RewardsReporting.Heading'), // unuse
  '/ethereum': t('EthereumStaking.Heading'),
  '/ethereum/staking': t('my_staking.Heading.Title'),
  '/ethereum/rewards': t('rewards.title'),
};

// Function to format route segments into readable labels
function formatSegment(segment: string) {
  // Check if we have a custom label first
  if (routeLabels[segment]) {
    return routeLabels[segment];
  }
  // Convert kebab-case and snake_case to Title Case
  return segment
    .split(/[-_]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function AppBreadcrumb() {
  const segments = useSelectedLayoutSegments();
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {segments.map((segment, i) => {
          const href = '/' + segments.slice(0, i + 1).join('/');
          const label = formatSegment(href);
          const isLast = i === segments.length - 1;
          return (
            <Fragment key={href}>
              {i != 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link href={href}>{label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
